<template>
    <v-layout row wrap>
        <v-row class="vertical ma-0 pa-0" v-if="routes.length === 0">
            <v-flex xs12 class="center-text">
                <v-icon size="100" class="mb-2">
                    mdi-file-question-outline
                </v-icon>
                <p>
                    No routes found! Create a new route by clicking the truck symbol in the toolbar above
                </p>
            </v-flex>
        </v-row>
        <v-flex v-else :class="(selected && selected.id) && `hide-list`" xs12>
            <v-layout row wrap class="task-list">
                <v-flex
                    xs12
                    class="p-3"
                    v-for="(route, index) in routes"
                    :key="index">
                    <v-card
                        :ripple="false" v-bind:class="selected && route.id === selected.id ? 'pa-3 task-card card-selected' : 'pa-3 task-card'"
                        @click="selectIsolatedRoute(route)">
                        <v-layout row wrap>
                            <v-flex xs8 class="font-weight-bold">
                                {{ route.name }}
                            </v-flex>
                            <v-flex xs4 class="text-right grey-text">
                                {{ route.jobTasks.length }} Tasks
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs9 class="grey-text crew-line-height">{{  route.userRoutes ? route.userRoutes.length : 0 }} Members in crew</v-flex>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-flex xs3 v-on="on">
                                        <div class="edit-btn-wrapper">
                                            <v-btn
                                                @click="EditRouteProcess(route)" style="float: right;" height="32px" width="32px" small icon>
                                                <v-icon v-bind:color="selected && route.id === selected.id ? 'white' : 'success'">mdi-square-edit-outline</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-flex>
                                </template>
                                <span>Route Details</span>
                            </v-tooltip>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data: () => ({}),
        props: {
            EditRouteProcess: {
                type: Function,
                required: true
            }
        },
        methods: {
            ...mapActions({
                getIsolatedRoute: 'routes/getIsolatedRoute',
            }),
            selectIsolatedRoute(route) {
                this.getIsolatedRoute(route.id)
            },
        },
        computed: {
            ...mapGetters({
                routes: 'routes/routes',
                selected: 'routes/selectedRoute'
            })
        }
    }
</script>

<style>
    .crew-line-height {
        line-height: 1.3;
    }
    .center-text {
        text-align: center;
    }
    .task-list .grey-text {
        color: #b1b0b0;
    }

    .task-list .card-selected .grey-text {
        color: #ffffff;
    }

    .task-list .card-selected {
        background-color: #44DAA5;
        color: #ffffff;
    }

    .task-list .card-flagged .grey-text {
        background-color: #ff5b5b !important;
        color: #ffffff;
    }

    .task-list {
        height: 100%;
        padding: 8px 0;
    }

    .task-list .task-card:hover {
        cursor: pointer;
        position: relative;
    }

    .vertical {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 70vh;
    }

</style>
